import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import moment from 'moment';
import { useContext, useEffect, useMemo, useState } from 'react';

import { QuickPricerContext } from '../../../../providers/otc-trader/quick-pricer-provider';
import SurfaceTrades from '../surface-trades';

import './styles.scss';

const QuickPricer = () => {
  const { calculateAllTrades, lastCalculation } = useContext(QuickPricerContext);

  const [dateIsOld, setDateIsOld] = useState(false);

  const renderLastCalculation = useMemo(() => {
    if (!lastCalculation || !moment.utc(lastCalculation).isValid) return null;

    return (
      <div className={`last-calculation`}>
        <span>Last calculation: </span>

        <div className={`calculation-date ${dateIsOld ? 'old-time' : ''}`}>
          <FontAwesomeIcon icon={faCalendar} className="icon" />
          <span className={`${dateIsOld ? 'old-time' : ''}`}>
            {moment.utc(lastCalculation).format('DD MMM YYYY - HH:mm [UTC]')}
          </span>
        </div>
      </div>
    );
  }, [lastCalculation, dateIsOld]);

  useEffect(() => {
    const interval = setInterval(() => {
      checkIfOld();
    }, 5000);

    const checkIfOld = () => {
      const now = moment.utc();
      const lastUpdate = moment.utc(lastCalculation);

      if (lastUpdate.isBefore(now, 'minute')) {
        setDateIsOld(true);
        clearInterval(interval);
      } else {
        setDateIsOld(false);
      }
    };

    checkIfOld();

    return () => clearInterval(interval);
  }, [lastCalculation]);

  return (
    <div className="quick-pricer-container">
      <div className="quick-pricer-header">
        <h1>Quick Pricer</h1>

        <div className="calculate-container">
          {renderLastCalculation}
          <Button className="calculate-btn" onClick={calculateAllTrades}>
            <span>Calculate</span>
          </Button>
        </div>
      </div>

      <SurfaceTrades />
    </div>
  );
};

export default QuickPricer;
